import { CircularProgress } from "@material-ui/core";
import { VisibilityOutlined, VisibilityOffOutlined } from "@material-ui/icons";
import React, { Component } from "react";
import PinInput from 'react-pin-input';
import { connect } from "react-redux";
import Swal from 'sweetalert2';
import { forgot, reset, verificarCodigo, reenviarCodigo } from "../../crud/auth.crud";
import LoginBox from "../../components/login/LoginBox";
import InputCustom from "../../components/InputCustom";
import Button from "../../components/Button";
import HeaderAuth from "../../components/HeaderAuth";
import styles from "../../styles/ForgotPassword.module.scss";

const RESEND_STORAGE_KEY = "forgot_password_resend";

const getStoredResend = (email) => {
	try {
		const raw = localStorage.getItem(RESEND_STORAGE_KEY);

		if (!raw) return null;

		const data = JSON.parse(raw);

		if (!data.resendAt) return null;

		if (email != null && data.email !== email) return null;

		return { email: data.email, resendAt: data.resendAt };
	} catch {
		return null;
	}
}

const setStoredResend = (email, resendAtMs) => {
	localStorage.setItem(RESEND_STORAGE_KEY, JSON.stringify({ email, resendAt: resendAtMs }));
}

const clearStoredResend = () => {
	localStorage.removeItem(RESEND_STORAGE_KEY);
}

const formatCountdown = (seconds) => {
	const minutes = Math.floor(seconds / 60);
	const secs = seconds % 60;
	return `${minutes}:${String(secs).padStart(2, "0")}`;
}

class ForgotPassword extends Component {
	constructor() {
		super();

		this.state = {
			email: "",
			loading: false,
			submitted: false,
			step: 1,
			codeInput: null,
			novaSenha: null,
			novaSenhaConfirm: null,
			mostrarSenha: false,
			mostrarSenhaConfirm: false,
			resendAvailableAt: null,
			resendSecondsLeft: 0,
			verificacao: {
				oitoCarac: false,
				letraMaiuscula: false,
				letraMinuscula: false,
				numero: false,
				caractereEspecial: false,
			}
		};

		this.resendTick = null;
	}

	componentDidMount() {
		const stored = getStoredResend();
		
		if (stored && stored.resendAt > Date.now()) {
			const secondsLeft = Math.max(0, Math.ceil((stored.resendAt - Date.now()) / 1000));
			this.setState({
				email: stored.email,
				step: 2,
				resendAvailableAt: stored.resendAt,
				resendSecondsLeft: secondsLeft,
			});
		} else {
			this.syncResendFromStorage();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.step === 2 && this.state.step !== prevState.step) {
			this.syncResendFromStorage();
		}
		
		if (this.state.step === 2 && this.state.resendAvailableAt != null) {
			if (!this.resendTick) {
				this.resendTick = setInterval(() => this.tickResendCountdown(), 1000);
			}
		} else if (this.resendTick) {
			clearInterval(this.resendTick);
			this.resendTick = null;
		}
	}

	componentWillUnmount() {
		if (this.resendTick) {
			clearInterval(this.resendTick);
		}
	}

	syncResendFromStorage() {
		const stored = getStoredResend(this.state.email || undefined);
		if (!stored || stored.resendAt <= Date.now()) {
			if (this.state.step === 2 && this.state.email) {
				this.setState({ resendAvailableAt: null, resendSecondsLeft: 0 });
			}
			clearStoredResend();
			
			return;
		}
		
		const secondsLeft = Math.max(0, Math.ceil((stored.resendAt - Date.now()) / 1000));
		
		this.setState({
			resendAvailableAt: stored.resendAt,
			resendSecondsLeft: secondsLeft,
			...(stored.email && !this.state.email ? { email: stored.email, step: 2 } : {}),
		});
	}

	tickResendCountdown() {
		const { resendAvailableAt } = this.state;
		
		if (!resendAvailableAt) return;
		
		const remaining = Math.max(0, Math.ceil((resendAvailableAt - Date.now()) / 1000));
		
		if (remaining === 0) {
			this.setState({ resendAvailableAt: null, resendSecondsLeft: 0 });
			clearStoredResend();
		} else {
			this.setState({ resendSecondsLeft: remaining });
		}
	}

	applyResendAvailableAt(resendAvailableAtSeconds) {
		const resendAtMs = resendAvailableAtSeconds * 1000;
		setStoredResend(this.state.email, resendAtMs);
		const secondsLeft = Math.max(0, Math.ceil((resendAtMs - Date.now()) / 1000));
		this.setState({ resendAvailableAt: resendAtMs, resendSecondsLeft: secondsLeft });
	}

	handleEmail = () => {
		if (!this.state.email) {
			return Swal.fire("Ops!", "O e-mail é uma informação obrigatória.", 'error')
		}

		if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.state.email)) {
			return Swal.fire("Ops!", "Você precisa informar um e-mail válido.", 'error')
		}

		this.setState({ submitted: true, loading: true });
		window.scrollTo(0, 0);

		forgot({ email: this.state.email })
			.then(response => {
				this.setState({ step: 2 });
				if (response.data && response.data.resend_available_at != null) {
					this.applyResendAvailableAt(response.data.resend_available_at);
				}
			})
			.catch(err => {
				Swal.fire("Ops!", err.response.data.errors[0] || "Erro ao enviar código", 'error')
			})
			.finally(() => {
				this.setState({ submitted: false, loading: false });
			});
	};

	handleReenviar = () => {
		if (!this.state.email) {
			return Swal.fire("Ops!", "E-mail não encontrado. Por favor, recarregue a página.", 'error');
		}
		if (this.state.resendSecondsLeft > 0) return;

		this.setState({ submitted: true, loading: true });

		reenviarCodigo({ email: this.state.email })
			.then(response => {
				Swal.fire("Sucesso!", "Código reenviado com sucesso", 'success');
				if (response.data && response.data.resend_available_at != null) {
					this.applyResendAvailableAt(response.data.resend_available_at);
				}
			})
			.catch(err => {
				const data = err.response?.data;
				if (data?.resend_available_at != null) {
					this.applyResendAvailableAt(data.resend_available_at);
				}
				Swal.fire("Ops!", data?.errors?.[0] || "Erro ao reenviar código", 'error');
			})
			.finally(() => {
				this.setState({ submitted: false, loading: false });
			});
	}

	handleCodigo = (codeOverride) => {
		const code = codeOverride !== undefined && codeOverride !== null ? codeOverride : this.state.codeInput;

		if (!code || code.toString().length < 6) return;

		this.setState({ submitted: true, loading: true });

		verificarCodigo({ email: this.state.email, codigo: code })
			.then(response => {
				this.setState({ step: 3 });
			})
			.catch(err => {
				Swal.fire("Ops!", err.response.data.errors[0] || "Erro ao verificar código", 'error')
			})
			.finally(() => {
				this.setState({ submitted: false, loading: false });
			});
	}

	handleShow = (marcador) => {
		this.setState((prevState) => ({
			[marcador]: !prevState[marcador]
		}))
	}

	verificarSenha = (senha) => {
		const verificacao = {
			oitoCarac: senha.length >= 8,
			letraMaiuscula: /[A-Z]/.test(senha),
			letraMinuscula: /[a-z]/.test(senha),
			numero: /\d/.test(senha),
			caractereEspecial: /[!@#$%&/+\-=[\]{}()*_.,;:<>?]/.test(senha),
		};

		this.setState({ verificacao });
	};

	handleEnviarSenha = () => {
		const { verificacao, novaSenha, novaSenhaConfirm } = this.state;
		const senhaInvalida = Object.values(verificacao).some(value => value === false);

		if (senhaInvalida) {
			return Swal.fire("Ops!", "Sua senha não atende aos requisitos mínimos.", 'warning');
		}

		if (novaSenha !== novaSenhaConfirm) {
			return Swal.fire("Ops!", "As senhas não coincidem.", 'warning');
		}

		this.setState({ submitted: true, loading: true });

		const data = {
			email: this.state.email,
			codigo: this.state.codeInput,
			password: novaSenha,
			password_confirmation: novaSenhaConfirm,
		};

		reset(data)
			.then(response => {
				Swal.fire("Sucesso!", "Sua senha foi alterada com sucesso.", "success").then(() => {
					this.props.history.push('/auth/login');
				});
			})
			.catch(err => {
				Swal.fire("Ops!", err.response.data.errors[0] || "Erro ao alterar senha", 'error');
			})
			.finally(() => {
				this.setState({ submitted: false, loading: false });
			});
	};

	render() {
		return (
			<div className="login flex-column pin-screen">
				<HeaderAuth />
				<div className="login-inner flex-column">

					{this.state.step === 1 && (
						<LoginBox loading={this.state.loading} titulo={'Recupere sua senha'} subtitulo={'Insira o e-mail vinculado à sua conta para receber o código de recuperação da senha.'} voltar={'/auth/login'} size={'small'} customClass={'senha'}>
							<div>
								<InputCustom
									label={"Insira seu e-mail"}
									name={"emailRecupera"}
									type={"email"}
									value={this.state.email}
									onBlur={(event) => this.setState({ email: event.target.value })}
									onChange={(event) => this.setState({ email: event.target.value })}
									disabled={this.state.loading}
								/>
							</div>

							<div>
								<Button
									type="submit"
									disabled={this.state.loading}
									variant="primary"
									size="lg"
									height="lg"
									fullWidth={true}
									loading={this.state.loading}
									children="Enviar código"
									onClick={() => this.handleEmail()}
								/>
							</div>
						</LoginBox>
					)}

					{this.state.step === 2 && (
						<LoginBox loading={this.state.loading} titulo={'Código de recuperação'} subtitulo={'Insira abaixo o código de recuperação recebido no seu e-mail.'} size={'small'} customClass={'senha'}>
							<div className="pin-input flex-column">
								<PinInput
									key={'pinInput'}
									length={6}
									focus
									type="numeric"
									onChange={(value) => this.setState({ codeInput: value })}
									onComplete={(value) => {
										this.setState({ codeInput: value });
										this.handleCodigo(value);
									}}
									placeholder={'0'}
									inputStyle={{
										width: '56px',
										height: '56px',
										padding: '16px',
										borderRadius: '8px',
										fontFamily: 'Figtree',
										fontWeight: 600,
										fontStyle: 'SemiBold',
										fontSize: '16px',
										leadingTrim: 'NONE',
										lineHeight: '24px',
										letterSpacing: '0%',
									}}
								/>

								{this.state.submitted ? <CircularProgress color="inherit" style={{ color: "#007E8F", margin: '0 auto' }} size={20} /> :
									(
										<div className="text-center">
											{this.state.resendSecondsLeft > 0 ? (
												<h5 className="color-gray-7 mb-0" style={{ display: "inline-block" }}>
													Reenviar código ({formatCountdown(this.state.resendSecondsLeft)})
												</h5>
											) : (
												<h5 className="color-secondary-6 cursor-pointer mb-0" style={{ display: "inline-block" }} onClick={() => this.handleReenviar()}>
													Reenviar código
												</h5>
											)}
										</div>
									)
								}
							</div>

							<div>
								<Button
									type="button"
									disabled={this.state.submitted}
									loading={this.state.submitted}
									variant="primary"
									size="lg"
									height="lg"
									fullWidth={true}
									children="Recuperar senha"
									onClick={() => this.handleCodigo()}
								/>
							</div>
						</LoginBox>
					)}

					{this.state.step === 3 && (
						<LoginBox loading={this.state.loading} titulo={'Nova senha'} subtitulo={'Insira abaixo sua nova senha.'} size={'small'} customClass={'senha'}>
							<div className="flex-column" style={{ gap: '24px' }}>
								<div>
									<InputCustom
										label={"Nova senha"}
										name={"novaSenha"}
										type={this.state.mostrarSenha ? "text" : "password"}
										value={this.state.novaSenha}
										onChange={(event) => {
											const valor = event.target.value;
											this.setState({ novaSenha: valor });
											this.verificarSenha(valor);
										}}
										disabled={this.state.loading}
										icon_left={this.state.mostrarSenha ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
										icon_style={{ cursor: "pointer" }}
										onIconClick={() => this.handleShow('mostrarSenha')}
									/>
								</div>

								<div>
									<InputCustom
										label={"Confirmar nova senha"}
										name={"novaSenhaConfirm"}
										type={this.state.mostrarSenhaConfirm ? "text" : "password"}
										value={this.state.novaSenhaConfirm}
										onChange={(event) => this.setState({ novaSenhaConfirm: event.target.value })}
										disabled={this.state.loading}
										icon_left={this.state.mostrarSenhaConfirm ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
										icon_style={{ cursor: "pointer" }}
										onIconClick={() => this.handleShow('mostrarSenhaConfirm')}
									/>
								</div>
							</div>

							<div className={`deve-conter ${styles.requirements}`}>
								<p className={styles.title}>Sua senha deve conter:</p>
								<div className={`${styles.row} ${this.state.verificacao.oitoCarac ? styles.met : ""}`}>
									<i className={`fas fa-check-circle ${styles.icon}`} aria-hidden />
									<span>No mínimo 8 caracteres</span>
								</div>
								<div className={`${styles.row} ${this.state.verificacao.letraMinuscula ? styles.met : ""}`}>
									<i className={`fas fa-check-circle ${styles.icon}`} aria-hidden />
									<span>Ao menos 1 letra minúscula</span>
								</div>
								<div className={`${styles.row} ${this.state.verificacao.letraMaiuscula ? styles.met : ""}`}>
									<i className={`fas fa-check-circle ${styles.icon}`} aria-hidden />
									<span>Ao menos 1 letra maiúscula</span>
								</div>
								<div className={`${styles.row} ${this.state.verificacao.numero ? styles.met : ""}`}>
									<i className={`fas fa-check-circle ${styles.icon}`} aria-hidden />
									<span>Ao menos 1 número (0123456789)</span>
								</div>
								<div className={`${styles.row} ${this.state.verificacao.caractereEspecial ? styles.met : ""}`}>
									<i className={`fas fa-check-circle ${styles.icon}`} aria-hidden />
									<span>Ao menos 1 caractere especial (*!@#$%&/+-=)</span>
								</div>
							</div>

							<Button
								type="button"
								disabled={this.state.submitted}
								loading={this.state.submitted}
								variant="primary"
								size="lg"
								height="lg"
								fullWidth={true}
								children="Alterar senha"
								onClick={() => this.handleEnviarSenha()}
							/>
						</LoginBox>
					)}
				</div>
			</div>
		);
	}
}

export default connect(null, null)(ForgotPassword);
